<template>
    <div style="width: 100%">
        <div class="row mb-2">
            <div class="form-group col-12">
                <label for="client">{{ $t('client') }}</label>
                <Combobox
                    class="bg-white"
                    name='client'
                    :placeholder="$t('select_a_item')"
                    :options="clients"
                    :getOptionLabel="client => `${client.CLI_DSC} (${client.roteirization ? 'SIM' : 'NÃO'})`"
                    v-model="clientSelected"
                    :reduce="client => client.CLI_ID"
                />
            </div>
        </div>

        <div class="row mb-5" v-show="clientSelected">
            <div class="col-12">
                <button
                    v-if="!clientSelectedHasRoteirization"
                    class="btn btn-primary mr-2"
                    @click="setRoteirizationInClientesOpcoes(true)"
                >
                    Ativar Roteirização
                </button>

                <button
                    v-else
                    class="btn btn-danger"
                    @click="setRoteirizationInClientesOpcoes(false)"
                >
                    Desativar Roteirização
                </button>
            </div>
        </div>

        <div class="row mb-5">
            <div class="col-12">
                <b-table
                    responsive='xl'
                    bordered
                    hover
                    class="bg-white"
                    :items="vehicles"
                    :fields='fieldsLastPositions'
                >
                    <template #head(selected)>
                        <b-form-checkbox
                            :disabled="vehicles.length ? false : true"
                            class="text-center"
                            id="checkUncheckAll"
                            name="checkUncheckAll"
                            v-model="checkAll"
                            @change='checkUncheckAll()'
                        />
                    </template>

                    <template v-slot:cell(selected)="{item}">
                        <b-form-checkbox
                            class="text-center"
                            :id="'check'+item.VEI_ID"
                            :name="'checkbox'+item.VEI_ID"
                            @change='check(item.VEI_ID)'
                        />
                    </template>

                    <template v-slot:cell(maxfrota_routerizacao)={item}>
                        <button
                            style="pointer-events: none;"
                            class="btn btn-primary btn-circle"
                            :class="item.maxfrota_routerizacao ? 'btn-primary' : 'btn-danger'"
                        >
                            <i class="fas fa-code-branch " />
                        </button>
                    </template>
                </b-table>
            </div>
        </div>

        <div class="row mb-5" v-show="vehiclesSelected.length">
            <div class="col-12">
                <button
                    class="btn btn-primary mr-2"
                    @click="setRoteirization(true)"
                >
                    Ativar Selecionado(s)
                </button>

                <button
                    class="btn btn-danger"
                    @click="setRoteirization(false)"
                >
                    Desativar Selecionado(s)
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import { request } from '@/lib/http'

export default {
    name: 'Roteirization',
    components: {
        LoaderButton,
        Combobox
    },

    data () {
        return {
            fieldsLastPositions: [
                {
                    key: 'selected',
                    label: '',
                    class: ['text-center', 'align-content-center']
                },
                {
                    key: 'VEI_PLC',
                    label: this.$t('board')
                },
                {
                    key: 'VEI_DSC',
                    label: this.$t('description')
                },
                {
                    key: 'CLI_ID',
                    label: 'Roteirização',
                    formatter: (value, key, item) => {
                        return item.maxfrota_routerizacao
                            ? 'SIM'
                            : 'NÃO'
                    }
                },
                {
                    key  : 'maxfrota_routerizacao',
                    label: '',
                    class: ['text-center']
                }
            ],
            clients                       : [],
            clientSelected                : undefined,
            clientSelectedHasRoteirization: false,
            vehicles                      : [],
            vehiclesSelected              : [],
            checkAll                      : false
        }
    },

    watch: {
        clientSelected(id) {
            this.selectButton()
        }
    },

    methods: {
        async getClients() {
            const { dispatch } = this.$store
        
            dispatch('overlay/show', true)

            try {
                this.clients = await request({
                    url   : 'roteirization/clients',
                    method: 'get'
                })
            } catch (error) {
                console.log('error getting clients')
                this.clients = []
            } finally {
                dispatch('overlay/show', false)
            }
        },

        async getVehicles() {
            const { dispatch } = this.$store
        
            dispatch('overlay/show', true)
            
            try {
                this.vehicles = await request({
                    url   : '/vehicles',
                    method: 'get',
                    params: { client: this.clientSelected }
                })
            } catch (error) {
                this.vehicles = []
            } finally {
                dispatch('overlay/show', false)
            }
        },

        check(id) {
            const exist = this.vehiclesSelected.includes(id)

            exist
                ? this.vehiclesSelected.splice(this.vehiclesSelected.indexOf(id), 1)
                : this.vehiclesSelected.push(id)

            this.vehiclesSelected.length !== this.vehicles.length
                ? document.getElementById('checkUncheckAll').checked = false
                : document.getElementById('checkUncheckAll').checked = true
        },

        checkUncheckAll() {
            if (!this.checkAll) {
                this.vehicles.forEach(vehicle => document.getElementById('check'+vehicle.VEI_ID).checked = false)

                return this.vehiclesSelected = []
            }

            const ids = this.vehicles.map(vehicle => {
                document.getElementById('check'+vehicle.VEI_ID).checked = true
                
                return vehicle.VEI_ID
            })

            this.vehiclesSelected = ids
        },

        async setRoteirization(status) {
            const { dispatch } = this.$store
        
            dispatch('overlay/show', true)

            try {
                const { data } = await request({
                    url   : 'set-status-roteirization',
                    method: 'post',
                    data  : {
                        status,
                        vehicles: this.vehiclesSelected
                    }
                })

                await this.getVehicles()
                this.checkAll = false
                this.checkUncheckAll()
            } catch (error) {
                dispatch('notify/error', { message: 'Erro ao Ativar/Inativar Roteirização para o(s) veículo(s) selecionado(s).' })
            } finally {
                dispatch('overlay/show', false)
            }
        },

        async setRoteirizationInClientesOpcoes(status) {
            const { dispatch } = this.$store
        
            dispatch('overlay/show', true)

            try {
                const { data } = await request({
                    url   : 'set-status-roteirization-clientes-opcoes',
                    method: 'post',
                    data  : {
                        status,
                        client: this.clientSelected
                    }
                })

                await this.getVehicles()
                this.checkAll = false
                this.checkUncheckAll()

                await this.getClients()
                this.selectButton()
                
                dispatch('notify/success', { message: `Roteirização ${status ? 'Ativada' : 'Desativada'} para o cliente.` })
            } catch (error) {
                dispatch('notify/error', { message: `Erro ao ${status ? 'Ativar': 'Desativar'} Roteirização para o cliente.` })
            } finally {
                dispatch('overlay/show', false)
            }
        },

        selectButton() {
            const hasRoteirization = this.clients.find(client => client.CLI_ID === this.clientSelected && client.roteirization)

            this.clientSelectedHasRoteirization = hasRoteirization
                ? true
                : false

            this.getVehicles()
        }
    },

    async mounted () {
        await this.getClients()
    },
}
</script>